import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { Card } from '@mui/material';
import Button from '@mui/material/Button/Button';
import { useTranslation } from 'react-i18next';
import './styles.css';

interface CookieCardProps {
	setShowCookieCard: (show: boolean) => void;
}

export const CookieCard = ({ setShowCookieCard }: CookieCardProps) => {
	const { t } = useTranslation();
	const { navigateWithLanguage } = useLanguageNavigate();

	const handleAcceptAll = () => {
		localStorage.setItem('cookieConsent', 'accepted');
		setShowCookieCard(false);
	};

	const handleDeclineCookies = () => {
		localStorage.setItem('cookieConsent', 'declined');
		setShowCookieCard(false);
	};

	const handleManageCookies = () => {
		localStorage.setItem('cookieConsent', 'managed');
		setShowCookieCard(false);
	};

	return (
		<Card className="border-set m-[20px] h-max !shadow-custom-button absolute bottom-[1%] z-20 r-[50%] max-lg:bottom-0 max-lg:m-0 animate-fade-in">
			<div className="flex justify-between items-center border-b border-[#E9ECEF] px-[20px] pt-[20px] pb-[10px] max-lg:flex-col-reverse max-lg:pb-[15px]">
				<h3
					style={{ fontSize: '20px' }}
					className="text-dark font-[700] w-max max-lg:mt-[20px] max-lg:w-[100%] max-md:!mt-[8px] max-xsm:!w-[95%]"
				>
					{t('valuePrivacy')} 🍪
				</h3>
				<div className="flex justify-center items-center gap-[10px] max-md:hidden">
					{/* <Button
						className="w-max h-[42px] !text-dark !border-[#fff] font-[700] size-[14px] !py-[10px] !px-[20px] shadow-custom-button"
						variant="outlined"
						onClick={handleManageCookies}
					>
						{t('manageCookies')}
					</Button> */}
					<Button
						className="h-[42px] w-max  !text-dark !border-[#fff]  font-[700] size-[14px] py-[10px] px-[20px] shadow-custom-button"
						variant="outlined"
						onClick={handleDeclineCookies}
					>
						{t('declineCookies')}
					</Button>
					<Button
						className="h-[42px] w-max text-[#fff] font-[700] size-[14px] py-[10px] px-[20px] shadow-custom-button"
						variant="contained"
						onClick={handleAcceptAll}
					>
						{t('acceptAll')}
					</Button>
				</div>
			</div>
			<div className="flex flex-col p-[20px] max-xsm:items-center">
				<p className="h-max w-full  text-secondary font-[400] size-[16px] max-xsm:w-[95%]">
					{t('privacyInfo')}
				</p>
				<div className="mt-[20px] max-xsm:w-[95%]">
					<p className="w-max text-secondary font-[400] size-[16px] max-xsm:w-[95%] max-xsm:h-max">
						{t('moreInformation')}
						<Button
							className="text-primary !p-0 !capitalize !underline !ml-[4px]"
							variant="text"
							onClick={() => navigateWithLanguage('/cookies-policy')}
						>
							{t('cookiePolicy')}
						</Button>
					</p>
				</div>
			</div>
			<div className="hidden max-md:flex  max-md:flex-col-reverse max-md:gap-[10px] max-md:p-[20px] max-xsm:items-center">
				{/* <Button
					className="w-[100%] h-[42px] !text-dark !border-[#fff] font-[700] size-[14px] !py-[10px] !px-[20px] shadow-custom-button max-xsm:w-[95%]"
					variant="outlined"
					onClick={handleManageCookies}
				>
					{t('manageCookies')}
				</Button> */}
				<Button
					className="h-[42px] w-[100%]  !text-dark !border-[#fff]  font-[700] size-[14px] py-[10px] px-[20px] shadow-custom-button max-xsm:w-[95%]"
					variant="outlined"
					onClick={handleDeclineCookies}
				>
					{t('declineCookies')}
				</Button>
				<Button
					className="h-[42px] w-[100%] text-[#fff] font-[700] size-[14px] py-[10px] px-[20px] shadow-custom-button max-xsm:w-[95%]"
					variant="contained"
					onClick={handleAcceptAll}
				>
					{t('acceptAll')}
				</Button>
			</div>
		</Card>
	);
};
